import * as types from './types';

// Note: uid and email are now in the auth slice (state.auth)
// Note: billing is now in the billing slice (state.billing)
// Note: tags are now in the tags slice (state.tags.tags) - single source of truth
// This slice only contains user profile data from the backend
export const initialState = {
  fullName: '',
  role: 'reader',
  isDemoMode: false,
  IsPhoneVerified: false,
  Phone: '',
  accounts: [],
  accountId: '',
  companyName: '',
  accountSettings: null,
  accountUsage: null,
  defaultUnit: null
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_USER:
      return {
        ...initialState,  // Full reset to prevent stale data from previous user
        ...action.payload,
      };
    case types.SET_USER_ROLE:
      return {
        ...state,
        role: action.payload,
      };
    case types.SET_USER_FULLNAME:
      return {
        ...state,
        fullName: action.payload,
      };
    case types.SET_DEMO_MODE:
      return {
        ...state,
        isDemoMode: action.payload,
      };
    case types.SET_ACCOUNTS:
      return {
        ...state,
        accounts: action.payload,
      };
    case types.SET_ACCOUNT_ID:
      return {
        ...state,
        accountId: action.payload,
      };
    case types.SET_COMPANY_NAME:
      return {
        ...state,
        companyName: action.payload,
      };
    case types.SET_ACCOUNT_SETTINGS:
      return {
        ...state,
        accountSettings: action.payload,
      };
    case types.SET_ACCOUNT_USAGE:
      return {
        ...state,
        accountUsage: action.payload,
      };
    // Note: SET_TAGS removed - tags are now in state.tags.tags (single source of truth)
    case types.SET_DEFAULT_UNIT:
      return {
        ...state,
        defaultUnit: action.payload,
      };
    case types.SET_IS_PHONE_VERIFIED:
      return {
        ...state,
        IsPhoneVerified: action.payload,
      };
    case types.SET_USER_PROFILE:
      // Batched update of entire user profile (reduces re-renders)
      return {
        ...state,
        ...action.payload,
      };
    case types.LOGIN:
      // Just reset profile state - auth state (uid, email) is handled by auth slice
      return {
        ...initialState,
      };
    case types.LOGOUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default userReducer;